import assign from 'object-assign';

/**
 * [Dictionary Object literal key value pairs to be converted to hash table for quick lookups]
 * @param {Object[, Object]} values Object literal, multiple object arguments will be merged
 */
function Dictionary ( values ) {
    let l = arguments.length;
    if ( l > 0 ) {
        for ( let i = 0; i < l; i++ ) {
            const type = Object.prototype.toString.call( arguments[i] ).slice( 8, -1 ).toLowerCase();
            if ( type !== 'object' ) {
                throw new TypeError(
                    'upi.dictionary::Expects arguments to be type [object], recieved [' + type + '] instead' );
            }
        }

        this.values = assign.apply( null, arguments );
    }
    else {
        throw new TypeError( 'upi.dictionary::No arguments provided. Expects at least 1 argument.' );
    }
}

Dictionary.prototype = {
    store ( key, value ) {
        this.values[key] = value;
    },
    lookup ( key ) {
        return this.values[key];
    },
    contains ( key ) {
        return Object.prototype.propertyIsEnumerable.call( this.values, key );
    },
    each ( fn ) {
        const object = this.values;
        for ( let key in object ) {
            if ( Object.prototype.hasOwnProperty.call( object, key ) ) {
                fn( key, object[key] );
            }
        }
    }
};

export default Dictionary;
